"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PHONE_REGEX = /^(1-)?\d{3}[-]\d{3}[-]\d{4}$/;
exports.Validator = {
    name: "phone",
    errorMessage: "Entered value is in invalid format.",
    validate: function (value) { return PHONE_REGEX.test("" + value); },
};
